<template>
	<div class="text-justify">
		<div class="content-wrapper">
			<app-overlay-loader v-if="preloader" />
			<div class="row">
				<!-- Basic Info Form -->
				<div class="col-lg-12">
					<form
						ref="basicInfoForm"
						:data-url="'/transaction/lead/' + value.id"
						class="mb-0"
						:class="{ 'loading-opacity': preloader }"
					>
						<div class="row">
							<div class="col-lg-12">
								
								<div class="row">
									<div class="col-lg-12">
										<div class="container-title-page">
										<div class="header-title-page">Parents Information</div>
										</div>
									</div>
								</div>
								<div class="row">
									<!-- Parent First Name -->
									<div class="col-md-6">
										<div class="form-group">
											
											<div class="row">
												<div class="col-md-4">
													<label>Parent Name</label>
												</div>
												<div class="col-md-8">
													<div class="form-check">
														<input
															class="form-check-input"
															type="checkbox"
															value=""
															id="is_mother"
															v-model="isMother"
														/>
														<label
															class="form-check-label"
															for="is_mother"
														>
															Is Mother
														</label>
													</div>
												</div>
												<div class="col-md-12">
													<input
														type="text"
														v-model="basicInfo.parent_first_name"
														placeholder="Parent Name"
														name="parent_first_name"
														class="form-control"
														required
													/>
												</div>
											</div>
										</div>
									</div>
									
									<!-- Contact Number -->
									<div class="col-md-6">
										<div class="form-group">
											<label for="input_contact_number">
												Contact Number
											</label>
											<app-input
												id="input_contact_number"
												type="tel-input"
												v-model="
													basicInfo.contact_number
												"
												placeholder="Contact Number"
											/>
										</div>
									</div>
									
									<div class="col-md-6">
										<div class="form-group">
										<label>Email</label>
										<app-input
											type="email"
											v-model="basicInfo.parent_email"
											placeholder="Parent Email"
											name="parent_email"
											required
										/>
										</div>
									</div>
									<!-- <div class="col-md-4">
										<div class="form-group">
											<label> Area of Residency </label>
											<app-input
												type="advance-search-select"
												:loaded-per-time="10"
												v-model="input_aor"
												@input="setAreaOfResidency"
												:fetch-url="computedFetchUrlAreaResidency"
												placeholder="Area of Residency"
												list-value-field="name"
												:required="true"
											/>
										</div>
									</div>
									 -->
									<div class="col-md-3">
										<div class="form-group">
										<label>Area Of Residency</label>
										<app-input
											type="advance-search-select"
											:loaded-per-time="10"
											v-model="input_aor"
											@input="setAreaOfResidency"
											:fetch-url="computedFetchUrlAreaResidency"
											placeholder="Area of Residency"
											list-value-field="name"
											required
										/>
										</div>
									</div>
									<div class="col-md-3">
										<div class="form-group">
										<label><br></label>
										<app-input
											type="advance-search-select"
											:loaded-per-time="10"
											v-model="input_postcode"
											@input="setPostCodeValue"
											:fetch-url="`wilayah/village?city_id=${basicInfo.area_of_residency}`"
											placeholder="Area"
											list-value-field="full_location"
											required
										/>
										</div>
									</div>
									<!-- Parent Last Name -->
									<!-- <div class="col-md-6">
										<div class="form-group">
											<div class="row">
												<div class="col-md-4">
													<label>Parent Last Name</label>
												</div>
												<!-- is mother -->
												<!-- <div class="col-md-8">
													<div class="form-check">
														<input
															class="form-check-input"
															type="checkbox"
															value=""
															id="is_mother"
															v-model="isMother"
														/>
														<label
															class="form-check-label"
															for="is_mother"
														>
															Is Mother
														</label>
													</div>
												</div>
											</div>
											<input
												type="text"
												v-model="basicInfo.parent_last_name"
												placeholder="Parent Last Name"
												name="parent_last_name"
												class="form-control"
												required
											/>
										</div>
									</div> --> 
									
								</div>
								
								<div class="row">
									<div class="col-lg-12">
										<div class="container-title-page">
										<div class="header-title-page">Child Information</div>
										</div>
									</div>
								</div>
								<div class="row">
									<!-- Child First Name -->
									<div class="col-md-6">
										<div class="form-group">
											<label>Child Name</label>
											<input
												type="text"
												v-model="basicInfo.child_first_name"
												placeholder="Child Name"
												name="child_first_name"
												class="form-control"
												required
											/>
										</div>
									</div>
									
									<!-- Child Last Name -->
									<!-- <div class="col-md-6">
										<div class="form-group">
											<label>Child Last Name</label>
											<input
												type="text"
												v-model="basicInfo.child_last_name"
												placeholder="Child Last Name"
												name="child_last_name"
												class="form-control"
												required
											/>
										</div>
									</div> -->
									<!-- Place of Birth -->
									<!-- <div class="col-md-4">
										<div class="form-group">
											<label>Place of Birth</label>
											<app-input
												type="text"
												v-model="basicInfo.place_of_birth"
												placeholder="Place of Birth"
												:required="true"
											/>
										</div>
									</div> -->
								</div>
								<div class="row">
									<!-- Date of Birth -->
									<div class="col-md-6">
										<div class="form-group">
											<label
												>Date of Birth (dd-mm-yyyy)*
												<span class="required-star">*</span></label
											>
											<div class="d-flex gap-2">
												<app-input
													type="number"
													min="1"
													max="31"
													v-model="day"
													placeholder="DD"
													class="w-1/3"
												/>
												<app-input
													type="number"
													min="1"
													max="12"
													v-model="month"
													placeholder="MM"
													class="w-1/3"
												/>
												<app-input
													type="number"
													min="1900"
													max="2100"
													v-model="year"
													placeholder="YYYY"
													class="w-1/3"
												/>
												<!-- Hidden input untuk kirim format YYYY-MM-DD -->
												<input
													type="hidden"
													v-model="basicInfo.date_of_birth"
												/>

											</div>
										</div>
									</div>
									<!-- Gender -->
									<div class="col-md-6">
										<div class="form-group">
											<label>Gender</label>
											<app-input
												id="input_gender"
												type="radio"
												:list="genderLists"
												v-model="basicInfo.gender"
											/>
										</div>
									</div>
									<!-- Whatsapp Number -->
									<!-- <div class="col-md-6">
										<div class="form-group">
											<div class="row">
												<div class="col-md-4">
													<label
														for="input_whatsapp_number"
													>
														Whatsapp Number
													</label>
												</div>
												<!-- same as contact number -->
												<!-- <div class="col-md-8">
													<div class="form-check">
														<input
															class="form-check-input"
															type="checkbox"
															value=""
															id="same_as_contact_number"
															v-model="
																sameAsContactNumber
															"
														/>
														<label
															class="form-check-label"
															for="same_as_contact_number"
														>
															Same as Contact
															Number
														</label>
													</div>
												</div> -->
											<!-- </div>
											<app-input
												id="input_whatsapp_number"
												type="tel-input"
												v-model="
													basicInfo.whatsapp_number
												"
												placeholder="Whatsapp Number"
											/>
										</div>
									</div>  -->
									<!-- School Name -->
									<div class="col-md-6">
										<div class="form-group">
											<label> School Name </label>
											<app-input
												type="advance-search-select"
												:loaded-per-time="10"
												v-model="input_school_name"
												@input="setSchoolName"
												fetch-url="master/school"
												placeholder="School Name"
												list-value-field="name"
												required
											/>
										</div>
									</div>
									<!-- School Level -->
									<div class="col-md-6">
										<div class="form-group">
											<label> School Level </label>
											<app-input
												type="advance-search-select"
												:loaded-per-time="10"
												v-model="input_school_level"
												@input="setSchoolLevel"
												fetch-url="master/school-level"
												placeholder="School Level"
												list-value-field="name"
												required
											/>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-lg-12">
										<div class="container-title-page">
										<div class="header-title-page">CLC Information</div>
										</div>
									</div>
								</div>
								<div class="row">
									<!-- Nearest CLC Centre -->
									
									<div class="col-md-6">
										<div class="form-group">
										<label>How did you hear about us?</label>
										<app-input
											id="input_marketing_channels"
											placeholder="How did you hear about us?"
											type="multi-select"
											:list="marketingChannelLists"
											name="marketing_channels"
											list-value-field="value"
											v-model="basicInfo.marketing_channels"
											:isAnimatedDropdown="true"
											required
										/>
										</div>
									</div>
									<div class="col-md-6">
										<div class="form-group">
											<label> Nearest CLC Centre </label>
											<app-input
												type="advance-search-select"
												:loaded-per-time="10"
												v-model="input_center_id"
												@input="setCenterIdValue"
												fetch-url="master/center"
												placeholder="Nearest CLC Centre"
												list-value-field="name"
												required
											/>
										</div>
									</div>
									<div class="col-md-6">
										<div class="row">
											<div class="col-md-12">
												<label>What time would you like us to contact you?</label>
											</div>
											<div class="col-md-6">
												<div class="form-group">
												<app-input
													placeholder="What time would you like us to contact you?"
													type="search-select"
													:list="contactTimeLists"
													name="call_times"
													v-model="basicInfo.call_times"
													:isAnimatedDropdown="true"
													required
												/>
												</div>
											</div>
											<div class="col-md-6">
												<div class="form-group" style="padding-top:13px;">
												<app-input
													id="input_contact_type"
													:is-need-name="true"
													type="radio"
													:list="contactTypeLists" 
													v-model="basicInfo.contact_type" required
												/>

												</div>
											</div>
										</div>
									</div>
									
									<div class="col-md-6">
										<div class="form-group">
											<label>Additional Questions</label>
											<app-input
												type="text"
												v-model="basicInfo.additional_message"
												name="additional_message"
												placeholder="Any additional questions"
											/>
										</div>
									</div>									
								</div>
							</div>
						</div>

						<!-- Submit and Clear button -->
						<div class="mt-4 action-buttons">
							<button
								type="submit"
								class="btn btn-primary mr-2"
								:disabled="submitBasicInfoDisabled"
								@click.prevent="submitBasicInfoForm"
							>
								{{ $t("submit") }}
							</button>
							<!-- <button
								type="submit"
								class="btn btn-secondary"
								@click.prevent="clearBasicInfoForm"
							>
								{{ $t("clear") }}
							</button> -->
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { BasicInfoFormMixin } from "./BasicInfoFormMixin";
import GlobalHelperMixin from "../../../../../../Mixins/global/GlobalHelperMixin";

export default {
	mixins: [BasicInfoFormMixin, GlobalHelperMixin],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
		dataCarry: {},
	},
	computed: {
		computedFetchUrlAreaResidency() {
			const { province_id, country_id } = this.value.area_of_residency;
			let params = new URLSearchParams();
			if (province_id) params.append("province_id", province_id);
			if (country_id) params.append("country_id", country_id);
			return `master/city?${params.toString()}`;
		},
		formattedDate() {
			if (this.year && this.month && this.day) {
				const mm = String(this.month).padStart(2, '0');
				const dd = String(this.day).padStart(2, '0');
				return `${this.year}-${mm}-${dd}`;
			}
			return '';
		}
	},
	data() {
		
		const dob = this.value?.date_of_birth || "";

		const [year, month, day] = dob.split("-");

		return {
			preloader: false,
			day: day || "",
			month: month || "",
			year: year || "",
			isMother: this.value.parent?.is_mother == 1 ? true : false,
			sameAsContactNumber:
				this.value.parent?.is_whatsapp_same_as_contact == 1
					? true
					: false,
			submitBasicInfoDisabled: true,
			originalBasicInfo: {},
      		marketingChannelLists: [],
      		source_id: 0,
			basicInfo: {
				call_times: this.value.call_times,
				contact_type:this.value.contact_type,
				additional_message:this.value.additional_message,
          		marketing_channels: Array.isArray(this.value.marketing_channels)
									? this.value.marketing_channels.map(mc => mc.marketing_channel.id)
									: [],
				parent_id: this.value.parent?.id,
				parent_first_name: this.value.parent?.last_name_parents 
									? this.value.parent?.name + ' ' + this.value.parent?.last_name_parents 
									: this.value.parent?.name,
				// parent_last_name: this.value.parent?.last_name_parents || "",
				is_mother: this.value.parent?.is_mother == 1 ? true : false,
				child_first_name: this.value.surname 
								? this.value.name + ' ' + this.value.surname 
								: this.value.name,
				// child_last_name: this.value.surname,
				// place_of_birth: this.value.place_of_birth_name,
				date_of_birth: this.value.date_of_birth,
				gender: this.value.gender,
				contact_number: this.value.parent?.contact || "",
				contact_dial_code: this.value.parent?.contact_dial_code || "",
				parent_email: this.value.parent?.email_parents || "",
				// whatsapp_number: this.value.parent?.whatsapp || "",
				center_id: this.value.center_id || 0,
				school_name: this.value.school?.id,
				school_level: this.value.school_level?.id,
				area_of_residency: this.value.area_of_residency?.id,
				address_0_postcode: this.value.address_0_postcode?.id,
				parent_id: this.value.parent_id,
				same_as_contact_number:
					this.value.parent?.is_whatsapp_same_as_contact == 1
						? true
						: false,
			},
			genderLists: [
				{ id: 1, value: "Male" },
				{ id: 2, value: "Female" },
			],
			contactTimeLists: [
				{ id: "09.00 - 11.00", value: "09.00 - 11.00" },
				{ id: "11.00 - 13.00", value: "11.00 - 13.00" },
				{ id: "13.00 - 15.00", value: "13.00 - 15.00" },
				{ id: "15.00 - 17.00", value: "15.00 - 17.00" },
				{ id: "17.00 - 19.00", value: "17.00 - 19.00" },
			],
			contactTypeLists: [
				{ id: "Call", value: "Call"},
				{ id: "Chat", value: "Chat"}
			],
			// input_place_of_birth: this.value
			// 	? this.value.place_of_birth_full
			// 		? {
			// 				id: this.value.place_of_birth_full.id || 0,
			// 				name: this.value.place_of_birth_full.name || "",
			// 				code: this.value.place_of_birth_full.code,
			// 				is_active: this.value.place_of_birth_full.is_active,
			// 		  }
			// 		: {
			// 				id: this.value.place_of_birth_full?.id || 0,
			// 				name: this.value.place_of_birth_full?.name || "",
			// 				code: this.value.place_of_birth_full?.code,
			// 				is_active:
			// 					this.value.place_of_birth_full?.is_active,
			// 		  }
			// 	: {
			// 			id: this.value.place_of_birth_full.id || 0,
			// 			name: this.value.place_of_birth_full.name || "",
			// 			code: this.valu.place_of_birthe.code,
			// 			is_active: this.value.place_of_birth_full.is_active,
			// 	  },
			input_school_name: this.value
				? this.value.school
					? {
							id: this.value.school.id || 0,
							name: this.value.school.name || "",
							code: this.value.school.code,
							is_active: this.value.school.is_active,
					  }
					: {
							id: this.value.school?.id || 0,
							name: this.value.school?.name || "",
							code: this.value.school?.code,
							is_active: this.value.school?.is_active,
					  }
				: {
						id: this.value.school.id || 0,
						name: this.value.school.name || "",
						code: this.value.school.code,
						is_active: this.value.school.is_active,
				  },
			input_school_level: this.value
				? this.value.school_level
					? {
							id: this.value.school_level.id || 0,
							name: this.value.school_level.name || "",
							code: this.value.school_level.code,
							is_active: this.value.school_level.is_active,
					  }
					: {
							id: this.value.school_level?.id || 0,
							name: this.value.school_level?.name || "",
							code: this.value.school_level?.code,
							is_active: this.value.school_level?.is_active,
					  }
				: {
						id: this.value.school_level.id || 0,
						name: this.value.school_level.name || "",
						code: this.value.school_level.code,
						is_active: this.value.school_level.is_active,
				  },
			input_aor: this.value
				? this.value.area_of_residency
					? {
							id: this.value.area_of_residency.id || 0,
							name: this.value.area_of_residency.name || "",
							code: this.value.area_of_residency.code,
							is_active: this.value.area_of_residency.is_active,
					  }
					: {
							id: this.value.area_of_residency?.id || 0,
							name: this.value.area_of_residency?.name || "",
							code: this.value.area_of_residency?.code,
							is_active: this.value.area_of_residency?.is_active,
					  }
				: {
						id: this.value.area_of_residency.id || 0,
						name: this.value.area_of_residency.name || "",
						code: this.value.area_of_residency.code,
						is_active: this.value.area_of_residency.is_active,
				  },
			input_postcode: this.value?.address_0_postcode,
			input_center_id: this.value
				? this.value.center
					? {
							id: this.value.center.id || 0,
							name: this.value.center.name || "",
							is_active: this.value.center.is_active,
					  }
					: {
							id: this.value.center?.id || 0,
							name: this.value.center?.name || "",
							is_active: this.value.center?.is_active,
					  }
				: {
						id: this.value.center.id || 0,
						name: this.value.center.name || "",
						is_active: this.value.center.is_active,
				  },
		};
	},
	created() {

		this.originalBasicInfo = JSON.parse(JSON.stringify(this.basicInfo));
		this.getMarketingChannels();
		
	},
	methods: {
		// BASIC INFO FORM
        async getMarketingChannels() {
			axios
			.get("/marketing-channel?per_page=50")
			.then((response) => {
				this.marketingChannelLists = response.data.data.map((item) => ({
				id: item.id,
				value: item.name,
				}));
			})
			.catch((error) => {
				console.error("Error fetching data:", error);
			});
		},
		beforeSubmitBasicInfoForm() {
			this.preloader = true;
		},
		submitBasicInfoForm() {
			// Handle form submission here
			
			const fullName = (this.basicInfo.parent_first_name || '').trim();

			const parts = fullName.split(/\s+/);
			this.basicInfo.parent_first_name = parts[0];
			this.basicInfo.parent_last_name = parts.slice(1).join(" ") || "";

			const fullNameChild = (this.basicInfo.child_first_name || '').trim();

			const partsChild = fullNameChild.split(/\s+/);
			this.basicInfo.child_first_name = partsChild[0];
			this.basicInfo.child_last_name = partsChild.slice(1).join(" ") || "";
		  
			this.saveBasicInfoForm(this.basicInfo);

			this.basicInfo.child_first_name = this.basicInfo.child_last_name 
											? this.basicInfo.child_first_name + ' ' + this.basicInfo.child_last_name 
											: this.basicInfo.child_first_name;

			this.basicInfo.parent_first_name = this.basicInfo.parent_last_name 
											? this.basicInfo.parent_first_name + ' ' + this.basicInfo.parent_last_name 
											: this.basicInfo.parent_first_name;

			this.originalBasicInfo = JSON.parse(JSON.stringify(this.basicInfo));
			this.submitBasicInfoDisabled =
			JSON.stringify(this.basicInfo) ===
			JSON.stringify(this.originalBasicInfo);
		},
		afterSuccessBasicInfoForm(res) {
			this.$toastr.s(res.data.message);
		},
		afterFinalResponseBasicInfoForm() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterErrorBasicInfoForm(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clearBasicInfoForm() {
			// Clear form fields here
			this.basicInfo = {
				first_name: "",
				parent_name: "",
				last_name: "",
				contact_number: "",
				// place_of_birth: "",
				// whatsapp_number: "",
				date_of_birth: "",
				school_name: "",
				area_of_residency: "",
				school_level: "",
				center_id: "",
			};
			this.resetPlaceOfBirth();
			this.resetSchoolName();
			this.resetSchoolLevel();
			this.resetAreaOfResidency();
			this.resetCenterIdValue();

			this.fieldStatus = {
				isSubmit: false,
			};
			// this.basicInfo.custom_file = null;
		},

		// setPlaceOfBirth(data) {
		// 	this.basicInfo.place_of_birth = data.id;
		// 	if (data && data.hasOwnProperty("id")) {
		// 		this.basicInfo.place_of_birth = data.id;
		// 	}
		// },
		setSchoolName(data) {
			this.basicInfo.school_name = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.basicInfo.school_name = data.id;
			}
		},
		setSchoolLevel(data) {
			this.basicInfo.school_level = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.basicInfo.school_level = data.id;
			}
		},
		setAreaOfResidency(data) {
			this.basicInfo.area_of_residency = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.basicInfo.area_of_residency = data.id;
			}
		},
		setCenterIdValue(data) {
			this.basicInfo.center_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.basicInfo.center_id = data.id;
			}
		},
		// resetPlaceOfBirth() {
		// 	this.input_place_of_birth = {};
		// 	this.basicInfo.place_of_birth = "";
		// },
		resetSchoolName() {
			this.input_school_name = {};
			this.basicInfo.school_name = "";
		},
		resetSchoolLevel() {
			this.input_school_level = {};
			this.basicInfo.school_level = "";
		},
		resetAreaOfResidency() {
			this.input_aor = {};
			this.basicInfo.area_of_residency = "";
		},
		resetCenterIdValue() {
			this.input_center_id = {};
			this.basicInfo.center_id = "";
		},
			
		setPostCodeValue(data) {
			this.basicInfo.address_0_postcode = this.basicInfo.address_0_postcode;
			if (data && data.hasOwnProperty("id")) {
				this.basicInfo.address_0_postcode = data.id;
			}
		},
	},
	watch: {
		
		formattedDate(newVal) {
			this.basicInfo.date_of_birth = newVal;
		},
		isMother: {
			handler: function (val) {
				this.basicInfo.is_mother = val;
			},
			deep: true,
		},
		sameAsContactNumber: {
			handler: function (val) {
				this.basicInfo.same_as_contact_number = val;
				// if (val) {
				// 	this.basicInfo.whatsapp_number =
				// 		this.basicInfo.contact_number;
				// } else {
				// 	this.basicInfo.whatsapp_number = "";
				// }
			},
			deep: true,
		},
		basicInfo: {
			handler: function (val) {
				if (val.date_of_birth) {
					val.date_of_birth = this.formatDate(val.date_of_birth);
				}

				// Check if basicInfo has changed
				const isBasicInfoChanged =
					JSON.stringify(val) !==
					JSON.stringify(this.originalBasicInfo);

				// Update the submitBasicInfoDisabled based on the change status
				this.submitBasicInfoDisabled = !isBasicInfoChanged;
			},
			deep: true,
		},
	},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 40px;
}
/* .form-control {
	border: 3px solid;
} */
.required-star {
	color: red;
}

::v-deep(.header-title-page) {
  background-color: #ffeb3b; /* warna kuning */
  display: inline-block;
  padding: 3px 17px 0px 8px;
  font-family: Arial, sans-serif;
  position: relative;
  border-radius: 0px 0px 57px 0px;
  font-size: 18px;
  font-weight: 600;
}

::v-deep(.header-title-page::after) {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
}

::v-deep(.container-title-page) {
  border-bottom: 2px solid #ffeb3b;
  margin-bottom: 15px;
}
</style>
